import styled from "styled-components";
import { theme } from "ui/themes";

interface ContainerModalProps {
  stateModal: boolean;
}

export const ContainerModal = styled.div<ContainerModalProps>`
  display: ${({ stateModal }) => (stateModal ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  top: 0;
  right: 0;

  z-index: 999999;
  position: fixed;

  background-color: ${theme.colors.neutral["820"]};
`;

export const BoxModal = styled.div`
  background-color: ${theme.colors.neutral.white};
  border-radius: 0.15rem;
  position: relative;

  padding: 2rem;
  padding-right: 4rem;
  padding-left: 4rem;
`;
export const BoxActions = styled.div`
  display: flex;
  gap: 1rem;
`;

type ButtonCloseProps = {
  isSendingItemToCart: boolean;
};

export const ButtonClose = styled.div<ButtonCloseProps>`
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  cursor: ${({ isSendingItemToCart }) =>
    isSendingItemToCart ? "initial" : "pointer"};
`;

export const ButtonSuccess = styled.button`
  padding: 0.2rem 2rem;
  background-color: ${theme.colors.secondary["265"]};
  border: none;
  border-radius: 0.3rem;
  color: ${theme.colors.neutral.white};
  font-weight: 600;
  font-size: 1.2rem;
  cursor: pointer;
  transition: filter 0.2s ease-in-out;

  &:hover {
    filter: brightness(0.9);
  }

  &:disabled {
    opacity: 0.5;
    cursor: initial;
  }
`;

export const ButtonCancel = styled.button`
  padding: 1rem;
  border: none;
  background: none;
  color: ${theme.colors.neutral[900]};
  font-size: 1.2rem;
  text-decoration: underline;
  border-radius: 0.3rem;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.neutral["80"]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: initial;
  }
`;

export const Description = styled.div`
  color: ${theme.colors.neutral["520"]};
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  h3 {
    font-size: 1.4rem;
    font-weight: 500;

    span {
      color: ${theme.colors.primary["50"]};
      font-weight: 600;
      font-size: 1.45rem;
    }
  }

  span {
    font-size: 1.26rem;
    padding-top: 1rem;
  }
`;

export const TextCe = styled.div`
  color: ${theme.colors.neutral["520"]};
  font-size: 1.6rem;
  padding: 1.8rem 1.6rem;
`;
